import { InputField } from 'components'
import { LoaderButton, ToggleField } from 'components/molecules'
import ClassificationAsyncMultiselectField from 'domains/product-brand/molecules/async-multiselect-field'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import ProductBrandCreateSchema from './product-brand-create-schema'
import ProductBrandUpdateSchema from './product-brand-update-schema'

const propTypes = {
  handleSubmit : PropTypes.func.isRequired,
  productBrand : PropTypes.object
}

const ProductBrandForm = ({ handleSubmit, productBrand }) => (
  <Formik
    initialValues={{
      label           : productBrand?.label,
      url             : productBrand?.url,
      isSearchable    : productBrand?.is_searchable,
      classifications : productBrand?.classifications
    }}
    validationSchema={ productBrand ? ProductBrandUpdateSchema : ProductBrandCreateSchema }
    onSubmit={ handleSubmit }
  >
    {
      (formikBag) => (
        <Form>
          <InputField
            type="text"
            label="Label"
            name="label"
            required={ true }
          />
          <InputField
            type="text"
            label="URL"
            name="url"
            required={ true }
          />
          <ToggleField
            label="Is Searchable"
            name="isSearchable"
          />
          <ClassificationAsyncMultiselectField
            name={ 'classifications' }
            label='Classifications of Product Brand'
            placeholder='Select Clasifications'
            isEditAction= { productBrand? true: false }
            existingClassifications= { productBrand?.classifications }
            required={ true }
          />

          <LoaderButton
            isLoading={ formikBag.isSubmitting }
            block={ false }
            color='primary'
            type='submit'
            text={ productBrand ? 'Update' : 'Create' }
            className='float-right'
          />
        </Form>
      )
    }
  </Formik>
)

ProductBrandForm.propTypes = propTypes

export default ProductBrandForm